module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.4bb5ac5c.webp";